import React, { useContext } from 'react'
import { Avatar, Badge, Space, Tag } from 'antd'
import { COLORS } from '../../constants'
import { useMyProfile } from '../../hooks/user/myprofile'
import { Text, View } from '../../../styles/reactnative'
import { UserOutlined } from '@ant-design/icons'
import LevelIcon from '../LevelIcon'
import { SocketContext } from '../../../theme/SocketProvider'

const UserTagNoLive = ({
	userid,
	nickname = '',
	email = '',
	phone = '',
	uid = '',
	onClick,
	selected = false,
	style = {},
	level = undefined,
}: any) => {
	let showid = userid

	if (uid) {
		showid = uid
	} else if (email) {
		const tempemail = email.split('@')[0]
		showid = tempemail
	} else if (phone) {
		phone = phone.replace(/-/g, '')
		showid = phone
	}

	if (nickname && nickname != email) {
		showid = nickname
	}

	return (
		<Space.Compact
			direction="horizontal"
			size={'small'}
			onClick={onClick}
			style={{
				width: '100%',
				...style,
			}}>
			{level != undefined && <LevelIcon level={level} />}
			<Avatar
				size="small"
				icon={<Text size={9}>{userid}</Text>}
				style={
					selected
						? {
								marginRight: 5,
								backgroundColor: COLORS.primaryDark,
						  }
						: { marginRight: 5 }
				}></Avatar>
			<Space.Compact
				direction="horizontal"
				size={'small'}
				style={{ marginLeft: -7 }}>
				<Tag
					style={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						flexDirection: 'row',
						cursor: 'pointer',
						margin: 0,
						backgroundColor: '#333',
						color: COLORS.white,
					}}>
					{showid}
				</Tag>
			</Space.Compact>
		</Space.Compact>
	)
}

export default React.memo(UserTagNoLive)
